import { useMediaQuery, useTheme } from "@mui/material";

export const useMatchDownMd = () => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));
  return { matchDownMd };
};
